//新闻类型
import axios from "axios"
export default {
    getNewsClassAsync: async () => {
        return axios.get('/get_cate')
            .then((response) => response)
            .catch((error) => {
                console.log(error);
            });
    },
}

export function getNewsClass(){
    return axios.get('/get_cate');
}
